import { render, staticRenderFns } from "./ResourceManager.vue?vue&type=template&id=059e4c0c&"
import script from "./ResourceManager.vue?vue&type=script&lang=js&"
export * from "./ResourceManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports